let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  const domListener = (event) => {
    callback(event.detail);
  };

  document.addEventListener(eventName, domListener);

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
    document.removeEventListener(eventName, domListener);
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }

  if (typeof createThemeEvent === 'function') {
    document.dispatchEvent(createThemeEvent(eventName, data));
  } else {
    document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: data }));
  }
}
